import { z } from "zod";

export const userSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
});

export type User = z.infer<typeof userSchema>;

export async function listUsers(): Promise<User[]> {
  const response = await fetch("/api/users", { credentials: "include" });
  if (!response.ok) throw new Error("Failed to fetch users");
  return userSchema.array().parse(await response.json());
}
